import {StepperConfig} from '../../../../../projects/mydocma/import-export/src/lib/stepper/stepper.config';

export const stepperConfig: StepperConfig = {
    steps: [
    {
        name: 'dataMapping',
        label: 'export-stepper.fileDataMapping',
        icon: {
            number: 'image',
            edit: 'image',
            done: 'image'
        },
        optional: false,
        editable: true,
        enabled: false
    },
    {
        name: 'exportDataResult',
        label: 'export-stepper.step2',
        icon: {
            number: 'done',
            edit: 'done',
            done: 'done'
        },
        optional: false,
        editable: true,
        enabled: false
    }]
};
